import { RootState } from 'data/root.reducers';
import { Deployment } from 'data/types';

export const getDiscoverySettingBackupserviceUrl = (state: RootState): string =>
  state.discoveryXcipio.discoveryXcipioSettings['backupservice.url'] ?? '';
export const getDiscoverySettingMapDefaultHome = (state: RootState): string =>
  state.discoveryXcipio.discoveryXcipioSettings['networkTopology.defaultHome'] ?? '38,-98.5795';
export const getDiscoveryDeployment = (state: RootState): Deployment =>
  state.discoveryXcipio.discoveryXcipioSettings.deployment ?? 'andromeda';
export const getDiscoverySettingLanguage = (state: RootState): string =>
  state.discoveryXcipio.discoveryXcipioSettings.language ?? '';
export const getDiscoverySettingDateFormat = (state: RootState): string =>
  // The date format is in Java Date Format and should be converted to moment format before use
  state.discoveryXcipio.discoveryXcipioSettings.dateFormat ?? '';
export const getDiscoverySettingTimeFormat = (state: RootState): string =>
  // The time format is in Java Date Format and should be converted to moment format before use
  state.discoveryXcipio.discoveryXcipioSettings.timeFormat ?? '';
export const isDiscoverySettingAuditEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isAuditEnabled ?? false;
export const shouldAutomaticallyGenerateCaseName = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.shouldAutomaticallyGenerateCaseName ?? false;
export const shouldSelectAllHi3Interfaces = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.Warrant_bSelectAllHI3Interfaces ?? false;
export const isAttachmentEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.Warrant_bAttachments_enabled ?? false;
export const isWarrantDefaultExpireEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isWarrantDefaultExpireEnabled ?? false;
export const getWarrantDefaultExpireDays = (state: RootState): string =>
  state.discoveryXcipio.discoveryXcipioSettings.warrantDefaultExpireDays ?? '';
export const isAlertNotificationEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isAlertNotificationEnabled ?? false;
export const getAlertNotificationRowNumbers = (state: RootState): string =>
  state.discoveryXcipio.discoveryXcipioSettings.alertNotificationRowNumbers ?? '';
export const getAlertNotificationPollingTime = (state: RootState): string =>
  state.discoveryXcipio.discoveryXcipioSettings.alertNotificationPollingTime ?? '';
export const isAlertNotificationNewIPEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isAlertNotificationNewIPEnabled ?? false;
export const isAlertNotificationBufferingEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isAlertNotificationBufferingEnabled ?? false;
export const isAlertNotificationAuditDiscrepancyEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isAlertNotificationAuditDiscrepancyEnabled ?? false;
export const isAlertNotificationInterceptDynamicIPLookupEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isAlertNotificationInterceptDynamicIPLookupEnabled ?? false;
export const isTargetIdValidationEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.targetIdValidation ?? false;
export const isExtendedTargetValidationEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.extendedTargetValidation ?? false;
export const isDisplayLocDataInInterceptDropDownEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.displayLocDataInInterceptDropDown ?? false;
export const shouldOraclex123X3InterfacesSupportSS8Distributors = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.shouldOraclex123X3InterfacesSupportSS8Distributors ?? false;
export const isNetworkTopologyEnabled = (state: RootState): boolean =>
state.discoveryXcipio.discoveryXcipioSettings.isNetworkTopologyEnabled ?? true;
export const isEWarrantEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.xcEwarrantEnable ?? false;
export const isAlarmFeatureEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isAlarmFeatureEnabled ?? false;
export const isAlarmNotificationProfileEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isAlarmNotificationProfileEnabled ?? false;
export const isLoadingAppSettings = (state: RootState): boolean =>
  state.discoveryXcipio.isLoadingAppSettings ?? false;
export const isLocationRequired = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isLocationRequired ?? false;
export const isAppSettingLoaded = (state: RootState): boolean =>
  state.discoveryXcipio.isAppSettingLoaded ?? false;
export const openSearchUrl = (state: RootState): string =>
  state.discoveryXcipio.discoveryXcipioSettings.openSearchUrl ?? '';
export const getSslCertDir = (state: RootState): string =>
  state.discoveryXcipio.discoveryXcipioSettings.sslCertDir ?? '';
export const getXccaCertAuthorityNamePrefix = (state: RootState): string =>
  state.discoveryXcipio.discoveryXcipioSettings.xccaCaNamePrefix ?? '';
export const getAfsExportLimit = (state: RootState): number =>
  state.discoveryXcipio.discoveryXcipioSettings.afsExportLimit;
export const getCfsExportLimit = (state: RootState): number =>
  state.discoveryXcipio.discoveryXcipioSettings.cfsExportLimit;
export const isT1678HITlsEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isT1678HITlsEnabled ?? false;
export const is33108HITlsEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.is33108HITlsEnabled ?? false;
export const isIdentifierAssociationExtensionsEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings.isIdentifierAssociationExtensionsEnabled ?? false;
export const isSinglepointprovisioningEnabled = (state: RootState): boolean =>
  state.discoveryXcipio.discoveryXcipioSettings['singlepointprovisioning.enabled'] ?? false;

export const shouldUseNetworkTopologyMockData = (state: RootState): { [key: string]: number } | undefined => {
  const mockQuantities = (state.discoveryXcipio?.discoveryXcipioSettings?.shouldUseNetworkTopologyMockData as string)?.split(',');
  if (!mockQuantities) {
    return undefined;
  }

  const [afs, cfs, admf, mdf2, mdf3, ccpag] = mockQuantities;

  // TODO: once we agree the propety in dsc-override-properties become
  // something like 100,20,1,2,2,3 the || bellow must be set as zero
  return {
    afs: Number(afs) || 0,
    cfs: Number(cfs) || Number(afs),
    admf: Number(admf) || 1,
    mdf2: Number(mdf2) || 4,
    mdf3: Number(mdf3) || 4,
    ccpag: Number(ccpag) || 48,
  };

};
export const shouldUseNetworkTopologyDinamicLocations = (state: RootState): boolean =>
  state.discoveryXcipio?.discoveryXcipioSettings?.shouldUseNetworkTopologyDinamicLocations ?? false;
export const getNetworkTopologyMapTileServerURI = (state: RootState): string | undefined =>
  state.discoveryXcipio.discoveryXcipioSettings.networkTopologyMapTileServerURI ?? undefined;
export const getNetworkTopologyPollingTime = (state: RootState): string =>
  state.discoveryXcipio.discoveryXcipioSettings.networkTopologyPollingTime ?? '';
export const allowedTargetsToSetOptions = (state: RootState): string[] => {
  const allowedTargetsToSetOptionsStr = state.discoveryXcipio?.discoveryXcipioSettings?.allowedTargetsToSetOptions;

  if (!allowedTargetsToSetOptionsStr) {
    return [];
  }

  try {
    const allowedTargetsToSetOptions = JSON.parse(allowedTargetsToSetOptionsStr);

    if (!Array.isArray(allowedTargetsToSetOptions)) {
      return [];
    }

    return allowedTargetsToSetOptions;
  } catch (error: any) {
    return [];
  }
}
